<div class="session-verification-container">
  <div class="session-verification-content">
    <div *ngIf="loading" class="loading-section">
      <div class="spinner"></div>
      <h2> {{ 'general.verifying_session' | translate }}</h2>
      <p> {{ 'general.wait_session_verification' | translate }} </p>
    </div>

    <div *ngIf="!loading && errorMessage" class="error-section">
      <div class="error-icon">
        <i class="fa fa-exclamation-circle"></i>
      </div>
      <h2> {{ 'general.session_verification_failed' | translate }} </h2>
      <p>{{ 'general.invalid_session' | translate }}</p>
    </div>
  </div>
</div>
